import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Tween, ScrollTrigger } from 'react-gsap';
import MobileDetect from 'mobile-detect';
import styles from './Section.module.scss';

function Section({ scrub, start, end, className, children }) {
  const md = new MobileDetect(window.navigator.userAgent)
  return (
    <ScrollTrigger start={ start } end={ end } scrub={ !md.mobile() && scrub }>
      <Tween from={{ opacity: 0 }} to={{ opacity: 1 }}>
        <div className={ classnames(styles.section, className) }>
          { children }
        </div>
      </Tween>
    </ScrollTrigger>
  );
}

Section.propTypes = {
  scrub: PropTypes.bool,
  start: PropTypes.string,
  end: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

Section.defaultProps = {
  start: 'top bottom',
  end: 'top 25%',
};

export default Section;
